<template lang="html">
  <root class="admin-dish-add">

    <admin-nav></admin-nav>
    <page-header name="Add dish" :count="false"></page-header>

    <!-- Form -->
    <div class="container">
      <div class="row">
        <div class="col m6">
          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Name (EN)</label>
                <input type="text" v-model="dish.name.en">
              </div>
            </div>

            <div class="col m6">
              <div class="mui-textfield">
                <label>Name (AR)</label>
                <input type="text" v-model="dish.name.ar">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <label>Description (EN)</label>
              <textarea class="materialize-textarea" v-model="dish.description.en"></textarea>
            </div>

            <div class="col m6">
              <label>Description (AR)</label>
              <textarea class="materialize-textarea" v-model="dish.description.ar"></textarea>
            </div>
          </div>

          <div class="row">
            <div class="col m6">
              <div class="mui-textfield">
                <label>Price</label>
                <input type="number" v-model="dish.price" 
                maxlength="7" 
                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
              </div>
            </div>

            <div class="col m6">
              <div class="mui-select">
                <select v-model="dish.type">
                  <option value="dessert">Dessert</option>
                  <option value="main_dish">Main dish</option>
                  <option value="breakfast">Breakfast</option>
                </select>
                <label>Type</label>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col m12">
              <div class="file-field input-field">
                <div class="btn">
                  <span>Photo</span>
                  <input type="file" accept="image/jpeg" @change="uploadPhoto($event)">
                </div>
                <div class="file-path-wrapper">
                  <input class="file-path validate" placeholder="Compressed .jpeg, 1:1">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col m6">
          <table class="bottom-line">
            <tbody>
              <tr>
                <th>Name (EN)</th>
                <td>{{dish.name.en}}</td>
              </tr>
              <tr>
                <th>Name (AR)</th>
                <td>{{dish.name.ar}}</td>
              </tr>
              <tr>
                <th>Description (EN)</th>
                <td>{{dish.description.en}}</td>
              </tr>
              <tr>
                <th>Description (AR)</th>
                <td>{{dish.description.ar}}</td>
              </tr>
              <tr>
                <th>Price</th>
                <td>{{dish.price}}</td>
              </tr>
              <tr>
                <th>Type</th>
                <td>{{dish.type}}</td>
              </tr>
              <tr>
                <th>Display photo</th>
                <td><img :src="displayPhotoPreview" class="photo"></td>
              </tr>
              <tr>
                <th>Cover photo</th>
                <td><img :src="coverPhotoPreview" class="photo"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>



      <div class="row">
        <div class="col m4 offset-m4">
          <a class="waves-effect waves-light btn" :disabled="isSending" @click="add">Add</a>
        </div>
      </div>
    </div>

  </root>
</template>

<script>
import * as firebase from "firebase";

export default {
  data() {
    return {
      dish: {
        name: {
          en: "",
          ar: "",
        },
        description: {
          en: "",
          ar: "",
        },
        price: "",
        currency: "",
        type: "",

        // Unbind params
        is_instant: false,
        stock: 0,
        is_archived: false,
        timestamp: firebase.database.ServerValue.TIMESTAMP,
        business_key: "",
        business_name: { en: "", ar: "", en_lower_case: "" },
        user_key: "",
        is_display_photo_updated: true,
        is_cover_photo_updated: true,
      },

      isSending: false,
      photos: [],
      displayPhotoPreview: "",
      coverPhotoPreview: "",
    };
  },

  methods: {
    // Add dish
    add() {
      // All fields are required
      if (
        !this.dish.name.en ||
        !this.dish.name.ar ||
        !this.dish.description.en ||
        !this.dish.description.ar ||
        !this.dish.price ||
        !this.dish.type ||
        this.photos.length < 2
      )
        return Materialize.toast("All fields are required", 4000);

      // Prevent invalid userkey
      if (!this.$route.params.userKey || !this.$route.params.businessKey) {
        return Materialize.toast("Unable to process", 4000);
      }

      this.isSending = true;

      this.collectBusinessCurrency(
        this.$route.params.userKey,
        this.$route.params.businessKey
      ).then(() => {
        this.storeToFirebase();
      });
    },

    storeToFirebase() {
      this.dish.business_key = this.$route.params.businessKey;
      this.dish.user_key = this.$route.params.userKey;

      //Dish
      firebase
        .database()
        .ref("dishes")
        .push(this.dish)
        .then((dishSnap) => {
          let loop = 2;

          // Upload photos
          for (let photo of this.photos) {
            firebase
              .storage()
              .ref("dish/" + photo.type + "/" + dishSnap.key + ".jpeg")
              .put(photo.file)
              .then((photoSnap) => {
                loop--;
                // End loop
                if (!loop) {
                  Materialize.toast("Added", 4000);
                  this.$router.push({ name: "Dishes" });
                }
              });
          }
        });
    },

    collectBusinessCurrency(userKey, businessKey) {
      return new Promise((resolve, reject) => {
        firebase
          .database()
          .ref("businesses/" + businessKey)
          .once("value")
          .then((businessSnap) => {
            let businessData = businessSnap.val();
            this.dish.business_name.en = businessData.name.en;
            this.dish.business_name.ar = businessData.name.ar;
            this.dish.business_name.en_lower_case = businessData.name.en
              .replace(/\s/g, "")
              .trim()
              .toLowerCase();

            let country = businessSnap.val().country;

            firebase
              .database()
              .ref("countries/" + country + "/currency")
              .once("value")
              .then((currencySnap) => {
                this.dish.currency = currencySnap.val();
                resolve();
              });
          });
      });
    },

    // Upload Photo
    uploadPhoto(event) {
      // Collect photo
      let photo = event.target.files || event.dataTransfer.files;

      // Validate
      if (!photo) {
        Materialize.toast("Unable to upload photo", 4000);
        return;
      }

      var reader = new FileReader();
      reader.onload = (e) => {
        this.displayPhotoPreview = e.target.result;
        this.coverPhotoPreview = e.target.result;
      };

      reader.readAsDataURL(photo[0]);

      this.photos = [
        { type: "cover", file: photo[0] },
        { type: "display", file: photo[0] },
      ];
    },
  },
};
</script>

<style lang="scss">
.admin-dish-add {
  .photo {
    height: 75px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/DishAdd.vue